/**
 * @fileoverview POST handler for the "/apps/:app_group_id/stop_import_in_progress" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdStopImportInProgressCacheKeys } from "./constants";
import type { PostAppsAppGroupIdStopImportInProgressProps } from "./types";

export const postStopImportInProgress = reactQueryMutationAdapter(
  appsAppGroupIdStopImportInProgressCacheKeys,
  ({ importId, appGroupId }: PostAppsAppGroupIdStopImportInProgressProps): Promise<void> => {
    return fetch(`/apps/${appGroupId}/stop_import_in_progress`, "POST", { import_id: importId });
  }
);
